import store from "@/store";
import { isOrdersCrmEnabled } from "@/services/config";

const canAccessOrdersCrm = () =>
  isOrdersCrmEnabled &&
  (store.state.user?.permissions || []).includes("orders-crm.view");

const ordersCrmRoutes = [
  {
    path: "/orders-crm",
    name: "orders-crm",
    meta: {
      condition: canAccessOrdersCrm,
      redirectTo: { name: "home" },
    },
    component: () =>
      import(
        /* webpackChunkName: "orders-crm" */ "../components/orders-crm/OrdersCRM.vue"
      ),
  },
];

export default ordersCrmRoutes;
